import React, { createContext, useContext } from 'react';
import { styles } from './RichText.css';

const richTextSectionContext = createContext<string | undefined>(undefined);

// This can be used to override the default styles for article sections
export const RichTextSectionProvider = ({ classname, children }: { classname: string; children: React.ReactNode }) => {
  return <richTextSectionContext.Provider value={classname}>{children}</richTextSectionContext.Provider>;
};

export const RichTextSection = ({ children }: { children: React.ReactNode }) => {
  const style = useContext(richTextSectionContext) ?? styles.richTextSection;
  return <div className={style}>{children}</div>;
};
